// eslint-disable-next-line filenames/match-exported
import { message } from 'antd';
import { I18n } from '@ies/starling_intl';
import { api } from './axios';

export { default as axios, api } from './axios';
export default api;

/** 验证是否拥有某一特定的权限，如果没有会跳转到相应权限申请页面 */
export async function verifyPermission(
  permisionKey: string,
  projectID?: number,
  noShowError?: undefined | boolean,
): Promise<boolean> {
  let data = await api.get(
    `/v1/access_control/right/check_right?right_keys=${permisionKey}${
      projectID || projectID === 0 ? `&project_id=${projectID}` : ''
    }`,
  );
  if (data[permisionKey]) {
    return true;
  }

  // 没有权限就跳转到权限申请页面
  data = await api.get(
    `/v1/access_control/right/role?right_key=${permisionKey}`,
  );
  const roles = ['role_member', 'role_temporary_member'];
  if (data?.roles.length && projectID) {
    window.location.replace(
      `${
        window.location.origin
      }/role-permissions-apply/${projectID}/${JSON.stringify(roles)}`,
    );
  } else {
    message.destroy(); // 关闭其他全局提示，如有
    if (
      permisionKey !== 'right_site_project_week_report_read' &&
      !noShowError
    ) {
      message.warning(I18n.t('no_permission', {}, '无权限'));
    }
  }
  return false;
}

export async function OnlyverifyPermission(
  permisionKey: string,
  projectID?: number,
  noShowError?: undefined | boolean,
): Promise<boolean> {
  const data = await api.get(
    `/v1/access_control/right/check_right?right_keys=${permisionKey}${
      projectID || projectID === 0 ? `&project_id=${projectID}` : ''
    }`,
  );
  if (data[permisionKey]) {
    return true;
  }
  message.error(
    I18n.t(
      'no_permission!_please_contact_the_project_administrator_to_edit_',
      {},
      '没有权限！请联系项目管理员编辑。',
    ),
    3,
  );
  return false;
}

export async function QualityOnlyverifyPermission(
  permisionKey: string,
  projectID?: number,
  noShowError?: undefined | boolean,
): Promise<boolean> {
  const data = await api.get(
    `/v1/access_control/right/check_right?right_keys=${permisionKey}${
      projectID || projectID === 0 ? `&project_id=${projectID}` : ''
    }`,
  );
  if (data[permisionKey]) {
    return true;
  }
  if (!noShowError) {
    message.error(
      I18n.t(
        'no_permission!_please_contact_the_administrator_to_add_the_qa_person_in_charge_p',
        {},
        '没有权限！请联系管理员添加QA负责人权限。',
      ),
      3,
    );
  }
  return false;
}
